export enum ImportStatusEnum {
    SUCCESSFUL = 'SUCCESSFUL',
    FAILED = 'FAILED',
    PARTIALLY_SUCCESSFUL = 'PARTIALLY_SUCCESSFUL',
}
